export default "__VITE_ASSET__Cpvu2W3L__"